module.exports = __webpack_public_path__ + "static/media/avatar-21.25e632d7.svg";